module.exports = __webpack_public_path__ + "img/perfectmoney.f8fe31f7.svg";